import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { ChatList, CreateChat, EditChat } from './components';

export const ChatsPage: React.FC = () => {
  return (
    <Routes>
      <Route index element={<ChatList />} />
      <Route path="create" element={<CreateChat />} />
      <Route path=":chatId" element={<EditChat />} />
    </Routes>
  );
};
